// src/hooks/useToast.js
import React, { useState, useEffect } from 'react';
import { CheckIcon, CloseIcon } from '../components/ui/Icons';
import { createPortal } from 'react-dom';

// --- INÍCIO DA ALTERAÇÃO ---
const Toast = ({ message, type = 'success', onClose, action }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, 5000); // Aumentado para 5s para dar tempo de clicar na ação
        return () => clearTimeout(timer);
    }, [onClose]);
    
    const baseClasses = "fixed bottom-5 right-5 z-50 flex items-center justify-between p-4 rounded-lg shadow-lg text-white animate-fade-in-up w-auto max-w-sm";
    const typeClasses = { success: 'bg-emerald-500/80 backdrop-blur-sm', error: 'bg-red-500/80 backdrop-blur-sm', info: 'bg-sky-500/80 backdrop-blur-sm' };
    
    return createPortal(
        <div className={`${baseClasses} ${typeClasses[type]}`}>
            <div className="flex items-center">
                {type === 'success' && <CheckIcon size={20} className="mr-3" />}
                {type === 'error' && <CloseIcon size={20} className="mr-3" />}
                <span>{message}</span>
            </div>
            {action && (
                <button
                    onClick={() => {
                        action.onClick();
                        onClose();
                    }}
                    className="ml-4 px-3 py-1 bg-white/20 text-white text-xs font-bold rounded-full hover:bg-white/30 transition-colors"
                >
                    {action.label}
                </button>
            )}
        </div>,
        document.body
    );
};

const useToast = () => {
    const [toast, setToast] = useState(null);
    const showToast = (message, type = 'success', action = null) => setToast({ message, type, id: Date.now(), action });
    const closeToast = () => setToast(null);
    const ToastComponent = toast ? <Toast message={toast.message} type={toast.type} onClose={closeToast} action={toast.action} /> : null;
    return { showToast, ToastComponent };
};
// --- FIM DA ALTERAÇÃO ---

export default useToast;